import React, { useEffect, useMemo } from "react";
import { getFormConfig } from "../data/gameEvents.js";
import './form.css'
import { FULL_WIDTH, MEDIA_ARTICLE, MEDIA_NOTATION, MEDIA_QUESTIONBOX, MEDIA_QUIZZ, MEDIA_SURVEY } from "../data/constants.js";
import { extractImagesFromContent, uploadImages } from "../../../../../components/Live/import/article/imageResolver.js";
import { createArticle, updateArticle } from "../../../../../actions/article.js";
import { useDispatch } from "react-redux";
import { useDirect, useMatch } from "../DirectContext.js";
import { createSurvey, updateSurvey } from "../../../../../actions/sondage.js";
import { createGameFact, updateGameFact } from "../../../../../actions/gameFact.js";
import { createNotation, updateNotation } from "../../../../../actions/notation.js";
import { createQuizz, updateQuizz } from "../../../../../actions/quizz.js";
import { createQuestionBox, updateQuestionBox } from "../../../../../actions/questionBox.js";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import DsasButton from "../../../../components/DsasButton/DsasButton.js";
import useStyles from '../../../../../styles/global-mui.js';
import { useSubscription } from "../../../../hooks/useSubscription.js";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const extractRealId = (res) =>
  res?.id || res?._id || res?.data?.id || res?.payload?.id || res?.payload?._id;

const DynamicForm = ({ matchEvent, setMatchEvent, handleClosePost, onValidate, submitCallback,  upgradeTmpPostId, currentPostId }) => {

  const classes = useStyles()

  const dispatch = useDispatch()
  const directEvent = useDirect()
  const formConfig = getFormConfig(matchEvent.type);

  const { checkSubscription } = useSubscription(directEvent)

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const {options, sections, onInit} = formConfig

  // Récupère la meilleure source d'historique disponible
  const getExistingFacts = (directEvent) => {

    // console.log(directEvent)
    // adapte si directEvent.matchFacts / preview / history
    return directEvent?.gameFacts ?? directEvent?.events ?? [];
  };

  const handleInputChange = (key, value) => {

    // console.log('handleInputChange', key, value);

     if (isSubmitting) return;

  const before = JSON.stringify(matchEvent);

  const draft = Object.assign(
    Object.create(Object.getPrototypeOf(matchEvent)),
    matchEvent
  );

  // console.log('Draft before updateDetail:', draft);

  const existingFacts = getExistingFacts(directEvent);

  //TODO patch rapide mis en place pour différencier actu et match
  // à revoir plus tard
  // il faudra faire le return new object dans les deux cas, et pas muter l’instance
  // pour éviter l'erreur de React 'A component is changing the uncontrolled value state'
  // et l'erreur 'A component is changing an uncontrolled input to be controlled'
  // qui existe encore sur les matchEvents de type 'gamefactEventDTO' actuellement

  //A changer par "si MatchEventDTO vs si gamefactEventDTO" en étape 1
  // et étape 2 faire ce qui est décrit au dessus
  if (draft.type && (
      draft.type === MEDIA_QUESTIONBOX ||
      draft.type === MEDIA_ARTICLE ||
      draft.type === MEDIA_SURVEY ||
      draft.type === MEDIA_QUIZZ ||
      draft.type === MEDIA_NOTATION )
    ){ 

    const nextEvent = (typeof draft.updateDetail === 'function')
    ? draft.updateDetail(key, value, directEvent, existingFacts) // <-- retourne un NOUVEL objet
    : { ...draft, [key]: value };

    if (JSON.stringify(nextEvent) === before) return;

    // console.log('Updated no-gf matchEvent:', nextEvent);

    setMatchEvent(nextEvent); // <-- on set le nouvel objet, pas l’instance mutée

  }else {
    draft.updateDetail(key, value, directEvent, existingFacts)

    if (JSON.stringify(draft) === before) return;

    // console.log('Updated gf matchEvent:', draft);

    setMatchEvent(draft); // <-- on set l’instance mutée
    
  }

  
};

const handleSubmit = async () => {
  if (!isFormValid || isSubmitting) return;

  setIsSubmitting(true);

  try {

    let result;


    switch(matchEvent.type){
      case MEDIA_NOTATION: result=await submitNotation(); break;
      case MEDIA_ARTICLE: result=await submitArticle(); break;
      case MEDIA_SURVEY: result=await submitSurvey(); break;
      case MEDIA_QUIZZ: result=await submitQuizz(); break;
      case MEDIA_QUESTIONBOX: result=await submitQuestionBox(); break;
      default: result=await submitGamefact();
    }

     

    onValidate?.(matchEvent);
    submitCallback?.();

    // Mapping tmp_* -> réel si on a un id serveur
  //  const realId = extractRealId(result);
  //  if (realId && typeof upgradeTmpPostId === 'function' && typeof currentPostId !== 'undefined') {
  //    // NOTE : adapte realPostData selon ce que tu veux conserver/mettre à jour dans le post
  //    const realPostData = matchEvent.type === MEDIA_ARTICLE
  //      ? { event: { ...matchEvent, _id: realId } }
  //      : { event: { ...matchEvent, _id: realId } };
  //    upgradeTmpPostId({ tmpId: currentPostId, realId, realPostData });
  //  }

   const realId = extractRealId(result); // lit result.id ou result._id...
  //  console.log('submission result:', result);
  //  console.log('extracted realId:', realId);
    if (realId) {
      upgradeTmpPostId?.({ tmpId: currentPostId, realId, realPostData: { event: { ...matchEvent, _id: realId } } });
    }

    handleClosePost();
   
  } catch (err) {
    console.error("Erreur lors de la soumission :", err);
    // ajouter message d'erreur UI (snackbar, alert…)
  } finally {
    setIsSubmitting(false);
  }
};


  const submitNotation = async () => {
    if(matchEvent._id)
      // Pas compris pourquoi on fait ça et ou le faire :
      // const res = await dispatch(updateNotation(detail, id));
      // const realId = extractRealId(res); // res = { ...payload serveur... }
      return dispatch(updateNotation({...matchEvent}, matchEvent._id))
    else
      return dispatch(createNotation({...matchEvent}, directEvent))
  }

  const submitArticle = async () => {
    let idEvent = directEvent.idMatch || directEvent.idActu;
    // Avant de submit, on doit envoyer les images au serveur, qu'il les enregistre et nous les retourne.
    const imagesToSave = await extractImagesFromContent(matchEvent.content, idEvent.toString() + "_" + new Date().getTime())
    
    let contentToSend = matchEvent.content
    
    if(imagesToSave.length > 0){
      const imageUrls = await uploadImages(imagesToSave)
    
      imageUrls.forEach(image => {
        const {imageUrl, imageName} = image
  
        // on recherche dans images toSave la base64 
        //dont imagestosave.imageName === imageName
        
        const associatedImage = imagesToSave.find(its => its.imageName === imageName)
  
        // en replace son base64 dans content par son url
        // Remplacez toutes les occurrences de la base64 par l'URL dans le contenu
        
        contentToSend = contentToSend.replace(associatedImage.toBeReplaced, imageUrl);
      })
    }

    if(matchEvent._id)
      return dispatch(updateArticle({...matchEvent, content : contentToSend}, matchEvent._id))
    else
      return dispatch(createArticle({...matchEvent, content : contentToSend}, directEvent))

  }

  const submitSurvey = async () => {
    if(matchEvent._id)
      return dispatch(updateSurvey(matchEvent, matchEvent._id))
    else
      return dispatch(createSurvey(matchEvent, directEvent))
  }

  const submitQuizz = async () => {
    if(matchEvent._id)
      return dispatch(updateQuizz(matchEvent, matchEvent._id))
    else
      return dispatch(createQuizz(matchEvent, directEvent))
  }

  const submitQuestionBox = async () => {
    if(matchEvent._id)
      return dispatch(updateQuestionBox(matchEvent, matchEvent._id))
    else
      return dispatch(createQuestionBox(matchEvent, directEvent))
  }

  const submitGamefact = async () => {
    if(matchEvent._id)
      return dispatch(updateGameFact(matchEvent.detail, matchEvent._id))
    else
      return dispatch(createGameFact(matchEvent.detail, matchEvent.type, directEvent, { isEnableTrigger : matchEvent.isEnableTrigger }))
  }

  const isEmpty = (value) => {
    if (value === undefined || value === null || value === "") return true;

    if (Array.isArray(value)) return value.length === 0;

    if (typeof value === 'object') return Object.keys(value).length === 0;

    return false; // pour les autres types (string, number, boolean), on les considère "remplis"
  };

  // Vérifie si au moins une section obligatoire n'est pas remplie
  const isFormValid = useMemo(() => {
    return !sections.some((section) => {
      if (!section.mandatory) return false;

      const keyIsInvalid = section.key && isEmpty(matchEvent[section.key]);
      const checkIsInvalid =
        section.checkValidation && !section.checkValidation(matchEvent);

      // si key ET checkValidation existent => les deux doivent être valides
      if (section.key && section.checkValidation) {
        return keyIsInvalid || checkIsInvalid;
      }

      // sinon, un seul des deux suffit
      if (section.key) return keyIsInvalid;
      if (section.checkValidation) return checkIsInvalid;

      // fallback: mandatory mais aucun moyen de valider => invalide
      return true;
    });
  }, [matchEvent, sections]);

  useEffect(() => {
    if(onInit && !matchEvent.__initialized)
    setTimeout(() => {
      onInit(matchEvent.options?.onInit)
      matchEvent.__initialized = true;
    }, 100); // Petit délai pour s'assurer que le composant est chargé
  }, []);

  
  const validSections = sections
                          // Filtrer les sections valides
                          .filter(section => !!section.type)
                          // Retirer les sections cachées avec la fonction hide
                          .filter(section => !section.hide || !section.hide(matchEvent, directEvent, checkSubscription));

  // Découper en deux colonnes équilibrées
  const midpoint = Math.ceil(validSections.length / 2);
  const leftSections = validSections.slice(0, midpoint);
  const rightSections = validSections.slice(midpoint);

  const isMediaArticle = MEDIA_ARTICLE === matchEvent.type;


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={isMediaArticle ? 12 : 6}>
        {leftSections.map((section, index) => {
          const Component = section.type;
          return (
            <Box key={index} mb={2} className="bordered-wrapper">
              {!section.label && section.mandatory && 
                <Box sx={{
                  marginTop: '-10px',
                  marginRight: '-5px',
                  height: '10px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end'
                }}>
                  <Box component="span" color="error.main">
                        &nbsp;*
                  </Box>
                </Box>
              }
              <Box className='centered-wrapper'>
                {section.label && <Typography variant='body1' fontWeight="bold" gutterBottom>
                  {section.label}
                  {section.mandatory && (
                      <Box 
                        component="span" 
                        color="error.main"
                        >
                        &nbsp;*
                      </Box>
                    )}
                </Typography>}
              </Box>
              <Component
                keyValue={section.key}
                directEvent={directEvent}
                event={matchEvent}
                onChange={handleInputChange}
                {...section}
              />
            </Box>
          );
        })}
      </Grid>

      <Grid item xs={12} md={isMediaArticle ? 12 : 6}>
        {rightSections.map((section, index) => {
          const Component = section.type;
          return (
            <Box key={index} mb={2} className="bordered-wrapper">
              {!section.label && section.mandatory && 
                <Box sx={{
                  marginTop: '-10px',
                  marginRight: '-5px',
                  height: '10px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end'
                }}>
                  <Box component="span" color="error.main">
                        &nbsp;*
                  </Box>
                </Box>
              }
              <Box className='centered-wrapper'>
                {section.label && <Typography fontWeight="bold" variant='body1' gutterBottom>
                  {section.label}
                  {section.mandatory && (
                    <Box component="span" color="error.main">
                      &nbsp;*
                    </Box>
                  )}
                </Typography>}
              </Box>
              <Component
                keyValue={section.key}
                directEvent={directEvent}
                event={matchEvent}
                onChange={handleInputChange}
                {...section}
              />
            </Box>
          );
        })}
      </Grid>

      {/* Bouton de validation */}
      <Grid item xs={12}>
        
        {!isFormValid && 
        <Box className='centered-wrapper'>
          <Typography 
              className={classes.customTypoColor} 
              padding='10px' 
              justifySelf='center' 
              fontSize="small" 
              fontStyle="italic"> Veuillez saisir les étapes obligatoires pour valider
          </Typography>
        </Box>
        }
        <Box className="form-section-end" mt={2}>
            <DsasButton
              label={isSubmitting ? 'Envoi en cours...' : 'Valider votre post'}
              variant="alternative"
              disabled={!isFormValid || isSubmitting}
              onClick={handleSubmit}
              icon={isSubmitting ? faSpinner : undefined}
            />
          {/* <button onClick={handleSubmit} disabled={!isFormValid}>
            VALIDER VOTRE POST
          </button> */}
        </Box>
      </Grid>
    </Grid>
  );

};

export default DynamicForm;